module.exports = __webpack_public_path__ + "static/img/001.b73b24a3.svg";